import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CmmImportBanners',
    props: {
        reimport: { type: Boolean },
        importing: { type: Boolean },
        disabled: { type: Boolean }
    },
    emits: ["reimport"],
    setup(__props, { emit: __emit }) {
        /** CoverMyMeds reimport and import-in-progress banners shown at the top of a PA. */
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_alert = _resolveComponent("v-alert");
            return (__props.reimport)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    variant: "tonal",
                    prominent: "",
                    class: "mb-4",
                    "data-testid": "cmm-reimport-banner"
                }, {
                    prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "large" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createTextVNode("mdi-account-alert", -1)
                                ]))]),
                            _: 1
                        })
                    ]),
                    append: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            color: "warning",
                            variant: "flat",
                            disabled: __props.disabled,
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('reimport')))
                        }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createTextVNode(" Reimport with corrected info ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-body-1 font-weight-bold mb-1" }, "Couldn't access this CMM submission", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-body-2 mb-3" }, " CoverMyMeds rejected the patient's last name or date of birth. Reimport with the corrected details to continue. ", -1))
                    ]),
                    _: 1
                }))
                : (__props.importing)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "info",
                        variant: "tonal",
                        prominent: "",
                        class: "mb-4",
                        "data-testid": "cmm-import-in-progress-banner"
                    }, {
                        prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "large" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode("mdi-progress-clock", -1)
                                    ]))]),
                                _: 1
                            })
                        ]),
                        default: _withCtx(() => [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-body-1 font-weight-bold mb-1" }, "Import in progress", -1)),
                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-body-2" }, " We're fetching this submission from CoverMyMeds. Check back shortly — you'll be emailed if the patient details don't match. ", -1))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true);
        };
    }
});
